/* eslint-disable */
// import { TextField } from '@mui/material';
// import { classes } from '../../../Helpers';
import { HighlightOff } from '@mui/icons-material';
import { CheckPicker, SelectPicker, TreePicker, Checkbox } from 'rsuite';
import {
	addCommas,
	classes,
	convertWeightUnit,
	getHigherUnit,
	getUnitConvertedUnit,
	options,
} from '../../../Helpers';
import CustomInputSelector from '../../CustomInputSelector/CustomInputSelector';
import styles from './TableRow.module.scss';
import CoreSpecifications from './CoreSpecifications';
import BoxContents from './BoxContents';
import { ProductListFilters } from '@/Components/Forms/Products';
import { Textarea } from '@/Components/ui/textarea';
import { useEffect, useMemo } from 'react';

const currencyTitles = [
	'Total Discount',
	'Sub total',
	'Total Tax',
	'Total Amount',
];

// countLabel: a count product's sub-unit ("Pax") - shown instead of "pc" when given.
const renderQtyInfo = (skuStockInfo, index, product, countLabel = null) => {
	return (
		<div className={styles?.quantitiesContainer}>

			{skuStockInfo?.map((infoEle) => {
				if (infoEle?.columnIndexToShowIn !== index) {
					return <></>;
				}
				const currentVariantValue = infoEle?.values?.[product?.selectedVariant?.id];
				return (
					<span
						className={styles?.quantities}
						style={{
							backgroundColor: infoEle?.bgColor,
							color: infoEle?.color,
						}}
					>
						<span className={styles?.title}>
							{infoEle?.name}
							:
						</span>
						<span className={styles?.value}>
							{currentVariantValue?.unit
								? `${currentVariantValue?.qty} ${currentVariantValue?.unit}`
								: countLabel && product?.unit === 'count'
									? `${Number(infoEle?.values?.[product?.selectedVariant?.id] ?? 0)} ${countLabel}`
									: convertWeightUnit(
									infoEle?.values?.[
									product?.selectedVariant?.id
									] ?? 0,
									product?.unit,
									undefined,
									true,
								)}
						</span>
					</span>
				);
			})}
		</div>
	);
};

function OEMSelector(props) {
	const { product, handleOemSelection } = props;
	return (
		<SelectPicker
			style={{
				width: '100%',
				fontSize: '11px',
				padding: '4px',
				margin: '4px 0',
				borderRadius: '4px',
			}}
			value={product?.oems?.find((oem) => oem?.isSelected)?.id || null}
			onChange={(selectedOemId) => {
				handleOemSelection([selectedOemId]);
			}}
			data={product?.oems?.map((oem) => ({
				label: oem.name,
				value: oem.id,
			}))}
			placeholder='Select OEM'
			searchable={false}
		/>
	);
}

function TableRow(props) {
	const {
		key,
		product,
		idx,
		quantity,
		handleQuantity = () => { },
		handleItemDescription = () => { },
		disabled,
		productWiseMappingData,
		handleSelection,
		productsList,
		servicesList = [],
		assetsList = [],
		handleRate,
		ratePerString = null,
		handleDiscount,
		addedItems = [],
		handleRemove = () => { },
		rowStyles,
		skuStockInfo,
		measurementType,
		handleTax = () => { },
		columns = [],
		handleOemSelection = () => { },
		handleSpecifications = () => { },
		isDeliveryChallan = false,
		isChangeable = true,
		rowError = {},
		handleChangeProductUnit = () => { },
		typeId,
		qtyRegex = null,
		customComponents = {},
		handleServiceAssetType = () => { },
		disableAll = false,
		handleInputBlur = () => { },
		handleItemComment = () => { },
		handleBatchId = () => { },
		handleBoxContent = () => { },
		handleBoxImages = () => { },
		boxContentsEnabled = false,
		handlePackSize = () => { },
		handlePacksRequired = () => { },
		canOrderInPacks = false,
		allItems = [], // Full state array to check for unique variant+pack combinations
		vendors = [],
		handleVendorSelection = () => { },
		handleTaxIncluded = () => { },
		packSizedOrder = false,
		groupedGstCodes = {},
		handleGstCodeSelection = () => { },
		onDropdownToggle = () => { },
		isScrolled = false,
		definedItemCharges = [],
		handleItemAdditionalCharges = () => { },
	} = props;

	// Count products: their sub-unit ("Pax") in place of pc/pcs/count/item, and what one unit
	// weighs (the variant's minWeight, grams) - null when not a count product / not set.
	const countLabel = product?.unit === 'count'
		? (productsList?.find((ele) => ele?.id === product?.productId)?.subUnitName ?? null)
		: null;
	const countWeightPerUnit = () => {
		if (product?.unit !== 'count') return null;
		const minWeight = Number(product?.selectedVariant?.minWeight);
		return minWeight > 0 ? Math.round(minWeight * 1000) / 1000 : null;
	};

	const applicableGstCodes = useMemo(() => {
		return groupedGstCodes[Number(product?.tax || 0)] || [];
	}, [groupedGstCodes, product?.tax]);

	useEffect(() => {
		if (typeId === 1 && applicableGstCodes.length === 1 && !product?.selectedGstCode) {
			handleGstCodeSelection(product?.id, applicableGstCodes[0].id, idx);
		}
	}, [typeId, applicableGstCodes, product?.selectedGstCode, product?.id, idx]);

	const tableRows = {
		'S.No': () => {
			return product?.unit ? (idx + 1) : '-';
		},
		'SERVICE': () => {
			return product?.productName ? (
				<>
					<div className={styles['added-item']}>
						{product?.productImageUrl && (
							<img src={product?.productImageUrl} alt='product' />
						)}
						<div className={styles['head-variants']}>
							<p>{product?.productName}</p>
							{product?.productName &&
								renderQtyInfo(skuStockInfo, 0, product)}
							<textarea
								className={styles['product-description']}
								value={product?.description ?? ''}
								onChange={(e) =>
									handleItemDescription(product?.id, e)
								}
								placeholder='comments'
							/>
						</div>
					</div>
				</>
			) : (
				<CustomInputSelector
					addedItems={typeId === 4 ? [] : addedItems}
					showImage
					handleSelection={handleSelection}
					inputLists={servicesList?.map((ele) => {
						return {
							...ele,
							name: ele?.name,
							imageUrl: ele?.image,
						};
					})}
					readOnly={disabled}
					skuStockInfo={skuStockInfo}
					addNewText='Add new Service'
					placeholder='Type or Click to select item'
					onDropdownToggle={onDropdownToggle}
				/>
			);
		},
		'ASSET TYPE': () => {
			return product?.assetTypeInfo ? (
				<>
					<div className={styles['added-item']}>
						{product?.assetTypeInfo?.productImageUrl && (
							<img src={product?.assetTypeInfo?.productImageUrl} alt='product' />
						)}
						<div className={styles['head-variants']}>
							<p>
								{product?.assetTypeInfo?.name}
							</p>
						</div>
					</div>
				</>
			) : (
				<CustomInputSelector
					addedItems={(typeId === 4 || typeId === 7) ? [] : addedItems}
					showImage
					handleSelection={(e) => handleServiceAssetType(product?.assetId ? product?.assetId : product?.id, e)}
					inputLists={assetsList?.map((ele) => {
						return {
							...ele,
							name: ele?.productName,
							imageUrl: ele?.productImageUrl,
						};
					})}
					readOnly={disabled}
					skuStockInfo={skuStockInfo}
					addNewText='Add new Asset Type'
					placeholder='Type or Click to select item'
				/>
			)
		},
		'ITEM DETAILS': () => {
			const perUnitWeight = countWeightPerUnit();
			return product?.productName ? (
				<>
					<div className={styles['added-item']}>
						{product?.productImageUrl && (
							<img src={product?.productImageUrl} alt='product' />
						)}
						<div className={styles['head-variants']}>
							<p className='flex flex-col gap-2'>
								<span>
									{product?.productName}
									{/* Asset Transfer Order rows are asset types, not variants — the
										bracket would just read "( Asset )" against every name. */}
									{typeId !== 7 && (
										<>
											(
											{product?.selectedVariant?.displayName ?? product?.variantName}
											)
										</>
									)}
								</span>
								{product?.selectedVariant?.clientVariantId ? <span className='text-xs font-semibold text-gray-500'>{product?.selectedVariant?.clientVariantId}</span> : product?.clientVariantId ? <span className='text-xs font-semibold'>{product?.clientVariantId}</span> : null}
								{perUnitWeight && (
									<span className='text-xs text-gray-500'>
										{perUnitWeight} g per {countLabel ?? 'pc'}
									</span>
								)}
							</p>
							{product?.productName &&
								renderQtyInfo(skuStockInfo, 0, product, countLabel)}
							{(typeId === 8 || typeId === 1) && (
								<Textarea
									placeholder='Comment'
									value={product?.comment}
									onChange={(e) =>
										handleItemComment(product?.id, e?.target?.value)
									}
									rows={1}
									className='min-h-0 h-7 py-1 resize-none text-xs'
								/>
							)}
						</div>
					</div>
					{/* Asset Transfer Orders reach this table only in non-spec mode, where items carry
						no core specs by design and the SPECIFICATIONS column is hidden
						(POItemSelection: capexOrderColumns filter). CAPEX (4) still warns. */}
					{typeId === 4 && product?.coreSpecifications.length === 0 && (
						<span className='text-xs text-red-400'>{`There is no Core Specifications for this ${product?.productName}`}</span>
					)}
					{product?.salesConsumptionUnit && (
						<span className='text-xs text-red-400'>
							(
							variant based on consumption unit
							)
						</span>
					)}
					{(typeId === 4 || typeId === 7) && product?.oems && (
						<OEMSelector
							product={product}
							handleOemSelection={(selectedOemsIds) => {
								handleOemSelection(idx, selectedOemsIds);
							}}
						/>
					)}
				</>
			) : (
				<CustomInputSelector
					addedItems={(typeId === 4 || typeId === 7) ? [] : addedItems}
					showImage
					handleSelection={handleSelection}
					inputLists={productsList?.map((ele) => {
						return {
							...ele,
							name: ele?.productName,
							imageUrl: ele?.productImageUrl,
						};
					})}
					readOnly={disabled}
					skuStockInfo={skuStockInfo}
					addNewText='Add new Product'
					placeholder='Type or Click to select item'
					packSizedOrder={packSizedOrder || canOrderInPacks}
					unpackedOption={canOrderInPacks}
					onDropdownToggle={onDropdownToggle}
				/>
			);
		},
		UNIT: () => {
			if (!product?.higherUnit) {
				return ' ';
			}
			return product?.higherUnit === 'count' ? (countLabel ?? 'pcs') : product?.higherUnit;
		},
		'QTY-INFO': () => {
			if (!product?.productName) return null;
			// Buyer SO from a BASE store: an "Assembled At Outlet" box shows what goes inside it,
			// editable.
			const isAssembledBox = boxContentsEnabled
				&& productsList?.find((ele) => ele?.id === product?.productId)?.freshlyPrepared;
			return (
				<>
					{renderQtyInfo(skuStockInfo, 2, product, countLabel)}
					{isAssembledBox && (
						<BoxContents
							product={product}
							productsList={productsList}
							disabled={disabled || disableAll}
							onChange={handleBoxContent}
							onImagesChange={handleBoxImages}
						/>
					)}
				</>
			);
		},
		'Batch Id': () => {
			return (
				<>
					<div className={classes(styles['editable-input'])}>
						{/* {customComponents?.QUANTITY?.(product)} */}
						<input
							className={classes(
								styles['custom-input'],
								rowError?.[product?.id]?.extraData?.batchId
									? styles.error
									: ''
							)}
							// type='number'
							readOnly={disabled}
							min={0}
							value={product?.extraData?.batchId}
							onChange={(e) => {
								const inputValue = e?.target?.value;
								handleBatchId(product?.id, inputValue);
							}}
							onBlur={() => handleInputBlur(product?.id)}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault();
									handleInputBlur(product?.id);
									e.target.blur();
								}
							}}
							placeholder='Batch Id'
							disbaled={!isChangeable}
						/>
					</div>
				</>
			);
		},
		'HSN Code': () => {
			const value = productsList.find((ele) => ele?.id === product?.productId)?.hsnCode;
			return (
				<p>{value || '-'}</p>
			);
		},
		SPECIFICATIONS: () => {
			return (
				<CoreSpecifications
					mode='rfq'
					showAllSpecs={false}
					className={styles['core-specs']}
					specifications={product?.coreSpecifications}
					onValueChange={(id, value) => {
						handleSpecifications(idx, id, value);
					}}
				/>
			);
		},
		'EXPECTED LEFT OVER': () => {
			return product?.expectedLeftOver ?? '-';
		},
		QUANTITY: () => {
			return (
				<>
					<div className={classes(styles['editable-input'])}>
						{customComponents?.QUANTITY?.(product)}
						<input
							className={classes(
								styles['custom-input'],
								rowError?.[product?.id]?.quantity
									? styles.error
									: ''
							)}
							type='number'
							readOnly={disabled}
							min={0}
							value={quantity}
							onChange={(e) => {
								const inputValue = e?.target?.value;
								let defaultRegex = /^(?:\d+(\.\d*)?|\.\d+)?$/;
								if (product?.higherUnit === 'count') {
									defaultRegex = /^\+?(0|[1-9]\d*)?$/;
								}
								const isPositiveDecimal = (
									qtyRegex ?? defaultRegex
								).test(inputValue);
								if (isPositiveDecimal) {
									handleQuantity(product?.id, inputValue, (typeId === 4 || typeId === 7 || typeId === 9 || canOrderInPacks) ? idx : null);
								}
							}}
							onBlur={() => handleInputBlur(product?.id)}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault();
									handleInputBlur(product?.id);
									e.target.blur();
								}
							}}
							placeholder='Quantity'
							disbaled={!isChangeable}
						/>
					</div>
					{product?.suggQty && <p className='text-xs text-blue-500 flex flex-row items-center text-nowrap'>Suggested Quantity: {product?.suggQty}</p>}
					{countWeightPerUnit() && Number(quantity) > 0 && (
						<p className='text-xs text-gray-500 text-nowrap'>
							= {Math.round(Number(quantity) * countWeightPerUnit()) / 1000} kg
						</p>
					)}
					{product?.higherUnit && (
						<div className={styles.input_unit}>
							<p
								style={{
									fontSize: '.8rem',
								}}
							>
								Quantity in
							</p>
							<div className={styles.unit_options}>
								{product?.productInputUnit && (
									<div className='bg-yellow-300 rounded-md m-2 p-1 text-center w-full'>
										{product?.productInputUnit === 'count' && countLabel
											? countLabel
											: product?.productInputUnit}
									</div>
								)}
								{/* {options?.[product?.productInputUnit]?.map(
									(ele) => {
										console.log(ele,"ele");
										console.log(product?.productInputUnit,"product?.productInputUnit");

										const isSelected =
											ele?.value ===
											product?.productInputUnit;
										return (
											<div
												onClick={() => {
													handleChangeProductUnit(
														product?.id,
														ele?.value
													);
												}}
												className={classes(
													styles.unit,
													isSelected
														? styles.selected
														: ''
												)}
											>
												{ele?.displayName}
											</div>
										);
									}
								)} */}
							</div>
						</div>
					)}
				</>
			);
		},
		VENDOR: () => {
			return (
				<SelectPicker
					data={vendors?.filter((v) => v?.vendorType?.toUpperCase() === 'FRIEGHT')?.map((v) => ({ label: v.name, value: v.id }))}
					style={{ width: '100%', fontSize: '11px' }}
					value={product?.vendorSelection?.selectedVendorId}
					onChange={(val) => handleVendorSelection(product?.id, val, idx, 'selectedVendorId')}
					menuStyle={{ width: '300px' }}
					placeholder='Select Vendor'
					disabled={disabled}
					searchable
				/>
			);
		},
		'RATE PER TON': () => {
			return (
				<div className='min-w-20'>
					<div className={classes(styles['editable-input'])}>
						<input
							type='text'
							className={classes(
								styles['custom-input'],
								rowError?.[product?.id]?.rate
									? styles.error
									: ''
							)}
							readOnly={disabled}
							min={0}
							value={product?.vendorSelection?.vendorRate}
							onChange={(e) => {
								const val = e.target.value;
								if (val === '' || /^\d*\.?\d*$/.test(val)) {
									handleVendorSelection(
										product?.id,
										val === '' ? null : val,
										idx,
										'vendorRate'
									);
								}
							}}
							placeholder='Rate'
							step='any'
						/>
					</div>
				</div>
			);
		},
		RATE: () => {
			const findIfPriceFixed = productWiseMappingData?.find((ele) => {
				return ele?.productId === product?.productId;
			});
			return (
				<div className='min-w-20'>
					<div className={classes(styles['editable-input'])}>
						<input
							type='text'
							className={classes(
								styles['custom-input'],
								rowError?.[product?.id]?.rate
									? styles.error
									: ''
							)}
							readOnly={disabled}
							min={0}
							value={
								product?.selectedVariant?.price === null
									? product?.productCost
										? product?.productCost
										: ''
									: product?.selectedVariant?.price
							}
							onChange={(e) => {
								const val = e.target.value;
								// max 3 decimals — BE stores productCost as DECIMAL(13,3)
								if (val === '' || /^\d*\.?\d{0,3}$/.test(val)) {
									handleRate(
										product?.id,
										val === '' ? null : val,
										(typeId === 4 || typeId === 9 || typeId === 7 || canOrderInPacks)
											? idx
											: null
									);
								}
							}}
							placeholder='Rate'
							step='any'
							disabled={
								product?.disabledPrice ||
								(!(
									typeId === 1 ||
									typeId === 8 ||
									typeId === 4 ||
									typeId === 7 ||
									typeId === 9
								) &&
									(!findIfPriceFixed?.mappingTypeElementValue ||
										findIfPriceFixed?.mappingTypeElementValue ===
										'0'))
							}
						/>
					</div>
					{product?.unit && product?.unit !== 'count' && (
						<p
							style={{
								fontSize: '.8rem',
							}}
						>
							{ratePerString} Rate per{' '}
							{options?.[product?.unit]?.[0]?.displayName}
						</p>
					)}
					{product?.unit === 'count' && (
						<p
							style={{
								fontSize: '.8rem',
							}}
						>
							{ratePerString}
							{typeId === 9
								? 'Service per charges per item'
								: `Rate per ${countLabel ?? 'item'}`}
						</p>
					)}
				</div>
			);
		},
		'Discount%': () => {
			const isPriceFixed = productWiseMappingData?.find((ele) => {
				return ele?.productId === product?.productId;
			});
			if (
				(typeId !== 4 || typeId !== 7) &&
				(!isPriceFixed?.mappingTypeElementValue ||
					isPriceFixed?.mappingTypeElementValue === '0')
			) {
				return (
					<p className={styles['disabled-value']}>
						{product?.discountPercentage
							? Number(product?.discountPercentage)?.toFixed()
							: 0}
					</p>
				);
			}
			return (
				<>
					<div className={styles['editable-input']}>
						<input
							type='text'
							className={styles['custom-input']}
							readOnly={disabled}
							value={
								product?.discountPercentage
									? product?.discountPercentage
									: product?.discountPercentage === '' ? '' : 0
							}
							onChange={(e) => {
								const inputValue = e.target.value;
								const pattern =
									/^(100(\.0+)?|\d{0,2}(\.\d{0,2})?)$/;
								if (pattern.test(inputValue)) {
									handleDiscount(
										product?.id,
										e?.target.value,
										canOrderInPacks ? idx : null
									);
								}
							}}
							placeholder='Discount %'
						/>
					</div>
				</>
			);
		},
		'Total Discount': () => {
			return (
				<div className={styles['editable-input']}>
					₹
					{addCommas(product?.totalDiscount ?? 0) ?? 0}
				</div>
			);
		},
		'SAC CODE': () => `${product?.sacCode ? product?.sacCode : '-'}`,
		'TAX %': () => {
			return (
				<div className='flex items-center gap-2'>
					{typeId === 1 && (
						<div className='flex flex-col items-start'>
							<Checkbox
								className='p-0'
								checked={product?.isTaxIncluded}
								onChange={(val, checked) => handleTaxIncluded(product?.id, checked, idx)}
							>
								<span style={{ fontSize: '10px', display: 'block', lineHeight: '1' }}>Tax<br />Incl.</span>
							</Checkbox>
						</div>)}
					<div className='flex flex-col justify-center gap-1' style={{ minWidth: '80px' }}>
						{[-1].includes(typeId) ? (
							<input
								type='number'
								className={styles['custom-input']}
								readOnly={disabled}
								style={{ width: '60px' }}
								value={product?.tax}
								onChange={(e) => handleTax(
									product?.id,
									e?.target.value,
									idx
								)}
								placeholder={product?.tax ? `${product?.tax}%` : 0}
							/>
						) : (
							<p className={styles['disabled-value']} style={{ marginBottom: '4px', width: 'fit-content', minWidth: '40px', textAlign: 'center' }}>
								{product?.tax ? `${product?.tax}%` : 0}
							</p>
						)}

						{typeId === 1 && applicableGstCodes.length > 0 && (
							<SelectPicker
								data={applicableGstCodes.map(gst => ({ label: gst.description ? `${gst.gst_code} - ${gst.description}` : gst.gst_code, value: gst.id, ...gst }))}
								style={{ width: '120px', fontSize: '11px' }}
								value={product?.selectedGstCode || null}
								onChange={(val, item) => handleGstCodeSelection(product?.id, val, idx)}
								placeholder='Select GST'
								cleanable={false}
								disabled={disabled}
								searchable={false}
							/>
						)}
					</div>
				</div>
			);
		},
		'Sub total': () => {
			return `₹${addCommas(product?.subTotal ?? 0) ?? 0}`;
		},
		'Total Tax': () => {
			return `₹${addCommas(product?.totalTax ?? 0) ?? 0}`;
		},
		'Total Amount': () => {
			if (isDeliveryChallan) {
				return `₹${Number(product?.subTotal ?? 0)?.toFixed(2) ?? 0}`;
			}
			return `₹${product?.selectedVariant
				? addCommas(product?.totalPriceIncTax ?? 0)
				: 0
				}`;
		},
		'PACK SIZE': () => {
			// Get pack sizes from the product's selectedVariant packSizeConfig
			const packSizes = product?.selectedVariant?.packSizeConfig || [];
			const selectedPackSize = product?.selectedPackSize;
			const availablePacks = selectedPackSize?.availableQty || 0;
			const currentVariantId = product?.selectedVariant?.id;

			// Get pack IDs that are already selected for this variant (excluding current row)
			const usedPackIdsForVariant = allItems
				?.filter((item, itemIdx) =>
					item?.selectedVariant?.id === currentVariantId &&
					item?.selectedPackSize?.id &&
					itemIdx !== idx
				)
				?.map((item) => item?.selectedPackSize?.id) || [];

			if (!product?.productName) {
				return '-';
			}

			// For canOrderInPacks mode
			if (canOrderInPacks) {
				// Build dropdown options with Unpacked as default
				const unpackedOption = { id: 'unpacked', quantity: 1, name: 'Unpacked' };
				const allPackOptions = [unpackedOption, ...packSizes];

				// If no packSizeConfig, show text only (Unpacked)
				if (packSizes.length === 0) {
					return (
						<div className='flex items-center justify-center'>
							<span className='text-sm font-medium bg-gray-100 px-3 py-1 rounded'>
								Unpacked (1)
							</span>
						</div>
					);
				}

				return (
					<div className='flex flex-col gap-1'>
						<SelectPicker
							style={{
								width: '100%',
								fontSize: '12px',
							}}
							value={selectedPackSize?.id || 'unpacked'}
							onChange={(selectedId) => {
								const selected = allPackOptions.find(p => p.id === selectedId);
								handlePackSize(product?.id, selected, idx);
							}}
							data={allPackOptions.map((pack) => ({
								label: pack.id === 'unpacked'
									? 'Unpacked (1)'
									: `Pack of ${pack.quantity}${pack.boxName ? ` (${pack.boxName})` : ''}`,
								value: pack.id,
								// Disable pack if already selected for this variant in another row
								disabled: usedPackIdsForVariant.includes(pack.id),
							}))}
							placeholder='Select Pack Size'
							searchable={false}
							cleanable={false}
							disabled={disabled}
							disabledItemValues={usedPackIdsForVariant}
						/>
					</div>
				);
			}

			// For packSizedOrder mode (existing logic)
			return (
				<div className='flex flex-col gap-1'>
					<SelectPicker
						style={{
							width: '100%',
							fontSize: '12px',
						}}
						value={selectedPackSize?.id || null}
						onChange={(selectedId) => {
							const selected = packSizes.find(p => p.id === selectedId);
							handlePackSize(product?.id, selected, idx);
						}}
						data={packSizes.map((pack) => ({
							label: `Pack of ${pack.quantity}${pack.boxName ? ` (${pack.boxName})` : ''}`,
							value: pack.id,
							// Disable pack if already selected for this variant in another row
							disabled: usedPackIdsForVariant.includes(pack.id),
						}))}
						placeholder='Select Pack Size'
						searchable={false}
						cleanable={false}
						disabled={disabled || packSizes.length === 0}
						disabledItemValues={usedPackIdsForVariant}
					/>
				</div>
			);
		},
		'PACKS REQUIRED': () => {
			if (!product?.productName) {
				return '-';
			}

			const variantId = product?.selectedVariant?.id;
			const packId = product?.selectedPackSize?.id;

			return (
				<div className={classes(styles['editable-input'])}>
					{customComponents?.QUANTITY?.(product)}
					<input
						className={classes(
							styles['custom-input'],
							rowError?.[product?.id]?.quantity
								? styles.error
								: ''
						)}
						type='number'
						readOnly={disabled}
						min={0}
						value={product?.quantity ?? ''}
						onChange={(e) => {
							const inputValue = e?.target?.value;
							let defaultRegex = /^(?:\d+(\.\d*)?|\.\d+)?$/;
							if (product?.higherUnit === 'count') {
								defaultRegex = /^\+?(0|[1-9]\d*)?$/;
							}
							const isPositiveDecimal = (
								qtyRegex ?? defaultRegex
							).test(inputValue);
							if (isPositiveDecimal) {
								// Pass variantId, packId, value, idx for unique variantId-packId mapping
								handlePacksRequired(variantId, packId, inputValue, idx);
							}
						}}
						onBlur={() => handleInputBlur(product?.id)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								e.preventDefault();
								handleInputBlur(product?.id);
								e.target.blur();
							}
						}}
						placeholder='Packs Required'
						disabled={!product?.selectedPackSize}
					/>
				</div>
			);
		},
		'NO. OF PCS TO BE PACKED': () => {
			if (!product?.productName) {
				return '-';
			}

			const packSize = product?.selectedPackSize?.quantity || 0;
			const packsRequired = product?.quantity || 0;
			const totalPcs = packSize * packsRequired;

			return (
				<div className='flex items-center justify-center'>
					<span className='text-sm font-medium bg-yellow-100 px-3 py-1 rounded'>
						{totalPcs}
					</span>
				</div>
			);
		},
		'FINAL QTY': () => {
			if (!product?.productName) {
				return '-';
			}

			const packSize = product?.selectedPackSize?.quantity || 1;
			const qty = product?.quantity || 0;
			const finalQty = packSize * qty;

			return (
				<div className='flex items-center justify-center'>
					<span className='text-sm font-medium bg-green-100 px-3 py-1 rounded'>
						{finalQty}
					</span>
				</div>
			);
		},
		'Additional Charges': () => {
			if (!product?.productName) {
				return '-';
			}
			const selectedCharges = product?.extraData?.additionalCharges || [];
			// Key selections by chargeCode — it is always present in the stored
			// `conditions`, so selections restore on edit without depending on an
			// async-fetched id lookup.
			const selectedIds = selectedCharges.map((c) => c?.chargeCode);
			const chargeLabel = (c) =>
				c?.chargeCode ? `${c?.chargeName} (${c?.chargeCode})` : c?.chargeName;
			const chargesTotal = selectedCharges.reduce(
				(sum, c) => sum + (Number(c?.price) || 0),
				0
			);
			const updateChargePrice = (chargeCode, val) => {
				const next = selectedCharges.map((sc) =>
					sc?.chargeCode === chargeCode
						? { ...sc, price: val === '' ? null : val }
						: sc
				);
				handleItemAdditionalCharges(product?.id, next, idx);
			};
			const removeCharge = (chargeCode) => {
				const next = selectedCharges.filter(
					(sc) => sc?.chargeCode !== chargeCode
				);
				handleItemAdditionalCharges(product?.id, next, idx);
			};
			return (
				<div className='flex flex-col gap-1.5' style={{ width: '260px' }}>
					<CheckPicker
						data={(definedItemCharges || []).map((c) => ({
							label: chargeLabel(c),
							value: c?.chargeCode,
						}))}
						value={selectedIds}
						style={{ width: '260px', fontSize: '11px' }}
						menuStyle={{ zIndex: 9999, width: '260px' }}
						onChange={(vals) => {
							const next = (vals || []).map((v) => {
								const existing = selectedCharges.find(
									(c) => c?.chargeCode === v
								);
								if (existing) return existing;
								const def = (definedItemCharges || []).find(
									(c) => c?.chargeCode === v
								);
								return {
									chargeId: def?.id ?? null,
									chargeCode: def?.chargeCode ?? v,
									chargeName: def?.chargeName,
									price: null,
								};
							});
							handleItemAdditionalCharges(product?.id, next, idx);
						}}
						placeholder='Select charges'
						searchable={false}
						disabled={disabled}
						cleanable
					/>
					{selectedCharges.length > 0 && (
						<div className='rounded-md border border-gray-200 bg-white overflow-hidden'>
							<div
								className='overflow-y-auto divide-y divide-gray-100'
								style={{ maxHeight: '180px' }}
							>
								{selectedCharges.map((c) => (
									<div
										key={c?.chargeCode}
										className='group flex items-center gap-2 px-2 py-1.5 hover:bg-gray-50'
									>
										<div className='flex min-w-0 flex-1 flex-col'>
											<span
												className='truncate text-[11px] font-semibold text-gray-700 leading-tight'
												title={c?.chargeName}
											>
												{c?.chargeName}
											</span>
											{c?.chargeCode && (
												<span className='text-[9px] font-medium uppercase tracking-wide text-gray-400 leading-tight'>
													{c?.chargeCode}
												</span>
											)}
										</div>
										<div className='flex shrink-0 items-center rounded border border-gray-200 bg-gray-50 focus-within:border-yellow-400 focus-within:bg-white'>
											<span className='pl-1.5 text-[11px] text-gray-400'>₹</span>
											<input
												type='text'
												readOnly={disabled}
												min={0}
												value={c?.price ?? ''}
												onChange={(e) => {
													const val = e.target.value;
													if (
														val === '' ||
														/^\d*\.?\d*$/.test(val)
													) {
														updateChargePrice(
															c?.chargeCode,
															val
														);
													}
												}}
												placeholder='0'
												className='w-14 border-0 bg-transparent px-1 py-0.5 text-right text-[11px] text-gray-800 outline-none'
											/>
										</div>
										{!disabled && (
											<HighlightOff
												onClick={() => removeCharge(c?.chargeCode)}
												className='shrink-0 cursor-pointer text-gray-300 opacity-0 transition-opacity hover:text-red-500 group-hover:opacity-100'
												style={{ fontSize: '15px' }}
											/>
										)}
									</div>
								))}
							</div>
							<div className='flex items-center justify-between border-t border-gray-200 bg-gray-50 px-2 py-1'>
								<span className='text-[10px] font-semibold uppercase tracking-wide text-gray-500'>
									{selectedCharges.length} charge
									{selectedCharges.length > 1 ? 's' : ''}
								</span>
								<span className='text-[11px] font-bold text-gray-700'>
									₹{addCommas(chargesTotal)}
								</span>
							</div>
						</div>
					)}
				</div>
			);
		},
	};

	const flatColumns = columns?.flatMap((ele) => {
		if (ele?.children?.length > 0) {
			return ele?.children;
		}
		return ele;
	});

	return (
		<tr
			key={product?.selectedVariant?.id}
			className={classes(styles['table-tr'], rowStyles)}
			aria-disabled={disableAll}
			style={{
				opacity: disableAll ? 0.5 : 1,
				pointerEvents: disableAll ? 'none' : 'auto',
			}}
		>
			{flatColumns?.map((ele) => {
				const isCurrency = currencyTitles?.includes(ele?.title);
				return (
					<td
						align={isCurrency && 'right'}
						style={{
							width: ele?.width,
							opacity: disableAll && '50',
							...(ele?.fixed ? {
								position: 'sticky',
								left: ele?.leftOffset || 0,
								zIndex: 10,
								background: rowStyles ? '#fffbe6' : 'white',
								boxShadow: (ele?.isLastFixed && isScrolled) ? '4px 0 8px -2px rgba(0,0,0,0.1)' : 'none',
							} : {}),
						}}
						aria-disabled={disableAll}
						onClick={() => {
							if (disableAll) {
								return;
							}
						}}
					>
						{tableRows?.[ele?.title]?.()}
					</td>
				);
			})}
			{product?.id && !disabled ? (
				<td
					onClick={() => {
						handleRemove(product, idx);
					}}
					className={styles['remove-cell']}
				>
					<HighlightOff className={styles.icon} />
				</td>
			) : (
				<td className={styles['remove-cell']} />
			)}
		</tr>
	);
}

export default TableRow;
